const feedbacks = {
  toasts: {
    create: {
      success: 'פידבק נוצר בהצלחה',
      error: 'אירעה שגיאה בעת יצירת הפידבק',
    },
    fetch: {
      error: 'אירעה שגיאה בעת שליפת הפידבקים',
    },
    delete: {
      error: 'אירעה שגיאה בעת מחיקת הפידבק',
    },
  },
  deleteModal: {
    header: 'מחיקת פידבק',
    body: 'אתה עומד למחוק פידבק',
    bulkBody: 'אתה עומד למחוק {{num}} פידבקים',
    success: 'הפידבק נמחק בהצלחה',
  },
  table: {
    headers: {
      date: 'תאריך',
      source: 'מקור',
      id: 'מזהה',
      externalId: 'מזהה חיצוני',
      flight: 'טיסה',
      airline: 'חברת תעופה',
      account: 'חשבון',
      driver: 'נהג',
      vehicle: 'רכב',
      feedback: 'פידבק',
      rating: 'דירוג',
      by: 'מאת',
      phone: 'טלפון',
      contact: 'יצירת קשר',
    },
    filters: {
      flight: 'טיסה',
      airline: 'חברת תעופה',
      driver: 'נהג',
      vehicle: 'רכב',
    },
    source: {
      crewLink: 'CrewLink',
      qr: 'QR',
      tripCard: 'כרטיס נסיעה',
    },
    actions: {
      delete: 'מחיקה',
    },
    toolTip: {
      noPermission: 'הפעולה לא מורשית: נדרשת הרשאה',
    },
  },
};

export default feedbacks;
